import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../constants/DropdownOptions";
import { counterpartyListAction,getOnboardcounterpartyListAction,updateRequest, deleteCounterPartyAction, editCounterPartyAction, getFarmerListConnectionAction } from "../../../modules/counterparties/action";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import InviteButtonTabHeader from "../../Common/InviteButtonTabHeader"
import CreateTable from "../../CreateTable";
import ConfirmationDialog from "../../FormElement/ConfirmationDialog";
import Loader from "../../Loader";
import CustomTooltip from "../../../utils/CustomTooltip";
import SimpleSnackbar from '../../SimpleSnackbar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from "moment";
import accept from "./../../../assets/images/accept.png";
import reject from "./../../../assets/images/payment.png"
import cancel from "./../../../assets/images/cloud-computing.png"
import view from "./../../../assets/images/view.png";
import connecting from "./../../../assets/images/agreement.png"
import Modal from '@material-ui/core/Modal';
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
      width: '100%',
  },
  heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: "white !important",
      boxShadow: "1px",
      padding: "20px",
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '16px',
      zIndex:12
  },
  exapansionPanel: {
      backgroundColor: '#00bc84',
      color: 'white',
      marginTop: '15px'
  }
});
class CounterpartyConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      orderfetchingComplete: false,
      dialogopen:false,
      headerRows: {
        timeStamp: "since",
        farmSize: "Farm Size",
        senderFarmName: "Farm Name",
        senderName: "Farmer Name",
        connectAction:"Status",
        connectStatus:"Action"
      },
      orderheaderRows: {
        // updatedAt: "Last Updated",
        // updatedBy: "Updated By",
        farmSize: "Farm Size",
        senderFarmName: "Farm Name",
        senderName: "Farmer Name",
        acceptAction: "Action"
      },
      order: "desc",
      connectedorder: "desc",
      orderBy: "id",
      ConnectdorderBy: "id",
      dialogId:'',
      diaogButtonText:'',
      diaogName:'',
      connected:true,
      ele:{},
      modalopen:false,
    };
  }

  componentDidMount() {
    const { getFarmerListConnectionAction } = this.props;
    getFarmerListConnectionAction()

  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.connections &&
      this.props.connections !== nextProps.connections &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteCounterPartyAction(id);
  };

  editRow = id => {
    const { rowData } = this.props;
    const requiredData = rowData.find(counterParty => counterParty.id === id);
    this.props.editCounterPartyAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  connectionhandleRequestSort = (event, property) => {
    const isDesc =
      this.state.connectedorderBy === property && this.state.connectedorder === "desc";
    this.setState({
      connectedorder: isDesc ? "asc" : "desc",
      connectedorderBy: property
    });
  };
  handleOpenDealog = (id,name, connect) => {
    this.setState({ dialogId: id });
    this.setState({connected:connect})
    this.setState({ dialogopen: true });
    this.setState({diaogName:name})
  }
  finalsubmit = (payload) => {
    this.props.updateRequest(payload, true)
  }
  handleModal =(value)=>{
    this.setState({modalopen:true})
    this.setState({ele:value})
  }

  handleFarmerInvite = () => {
    setTimeout(() => {
      this.props.getFarmerListConnectionAction();
    }, 1500);
  }
  convertorder = row => {
    let temp = row;
    for (let i = 0; i < temp.length; i++) {
      temp[i]['acceptAction'] = <div style={{display:'flex',gap:'10px'}}>
        {/* <button className="send-Request" onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,false)}> Take action</button> */}
           
  

{/* <CustomTooltip
      title={"Cancel"}
      ariaLabel="connect"
    >
       <img
       onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,false)}
           src={cancel} width={40} alt="cancel" />
          
          </CustomTooltip> */}

          <CustomTooltip
      title={"Accept"}
      ariaLabel="connect"
    >
      <img
             onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,true)}

    //   onClick={()=>{this.finalsubmit({  "connectionStatusEnum": "CONNECTED",
    //     "otherUserId": temp[i].senderId,
    // });
    //       }}
          
          src={accept} width={40} alt="accept" />
          
          </CustomTooltip>


<CustomTooltip
      title={"Reject"}
      ariaLabel="connect"
    ><img 
    onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,false)}

    // onClick={()=>{this.finalsubmit({  "connectionStatusEnum": "REQUEST_CANCELLED_BY_RECEIVER",
    //     "otherUserId": temp[i].senderId,
    // });
    //       }}
          
          src={reject} width={40} alt="reject" /></CustomTooltip>
<CustomTooltip
      title={"View details"}
      ariaLabel="connect"
    >
      <img 
            //  onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,false)}

      onClick={()=>{this.handleModal(this.props.connections.connectionRequest[i])
          }}
           src={view} width={40} alt="view" />
    </CustomTooltip>


      </div>
      // temp[i]['connectAction'] =  <button className="send-Request" onClick={()=>this.handleOpenDealog(temp[i].senderId,temp[i].senderFarmName,true)}> Take action</button>
      temp[i]['connectAction'] =  <span><CustomTooltip
      title={`Connected${this.props.connections.connected[i] ? ' on ' + this.props.connections.connected[i].timeStamp:""}`}
      ariaLabel="connect"
    >
      
      <img src={connecting} width={40} alt="reject" />
      
    </CustomTooltip>
  
    </span>
    temp[i]['connectStatus'] =   <CustomTooltip
    title={"View Farm Details"}
    ariaLabel="connect"
  >
    
    <img src={view} width={40} onClick={()=>{this.handleModal(this.props.connections.connected[i])
        }} alt="reject" />
    
  </CustomTooltip>
    }
    return temp;
  }
  handleClose = () => {
    this.setState({ dialogopen: false });
  };
  handleModalClose = () =>{
    this.setState({modalopen:false})
  }
  getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  render() {
    const { connections, classes } = this.props;
    const { fetchingComplete, order, orderBy,connectedorder, connectedorderBy, open, dialogId,diaogName,connected, payloadData, ele } = this.state;
    const prevPath = "farmsetup",
      currentPage = "/counterparties";
    return (
      <div className="ticket-body">
    
          <Dialog open={this.state.dialogopen} onClose={() =>this.handleClose()} aria-labelledby="form-dialog-title">
          <DialogContent>
            
          {connected?<p>Are you sure you want to accept connection request from {diaogName}?</p>:<p>  Do you really want to reject this item? This process can not be undone"
</p>}
         
        </DialogContent>
        <DialogActions>
        <button onClick={() =>this.handleClose()} className={connected?"reject":"blue"} color="primary">
            CANCEL
          </button>
          {/* {connected?<button className="accept" onClick={()=>{this.finalsubmit({  "connectionStatusEnum": "CONNECTION_REMOVED_BY_RECEIVER",
        "otherUserId": dialogId
    });
           this.handleClose()}} color="primary">
            Unfollow
          </button>: */}
          <div className={{display:'flex',gap:'10px'}}>
        {connected ?<button className="green" onClick={()=>{this.finalsubmit({  "connectionStatusEnum": "CONNECTED",
        "otherUserId": dialogId
    });
           this.handleClose()}} color="primary">
            ACCEPT
          </button>:
          <button className="reject" onClick={()=>{this.finalsubmit({  "connectionStatusEnum": "REQUEST_CANCELLED_BY_RECEIVER",
        "otherUserId": dialogId
    });
           this.handleClose()}} color="primary">
            REJECT
          </button>}
          </div>
          
        </DialogActions>
      </Dialog>
         <SimpleSnackbar />
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
              <Modal
                                      open={this.state.modalopen}
                                      onClose={() =>this.handleModalClose()}                                    >
                                      <div style={this.getModalStyle()} className={classes.paper}>
                                        <div className="modal-header">
                                        <h2 id="simple-modal-title">Farm Details:</h2>
                                        <span style={{cursor:"pointer"}} onClick={()=>this.handleModalClose()}> ❌ </span>
                                        </div>
                                        <p id="simple-modal-description">
                                            Name : <span>{ele.senderName}</span><br/>
                                            Email : <span>{ele.userName}</span><br/>
                                            Contact : <span>{ele.contactNo}</span> <br/>
                                            Farm Name : <span> {ele.senderFarmName}</span> <br/>
                                            Farm Size :  <span>{ele.farmSize}</span> <br/>
                                            {/* Load Date : <span>{moment(new Date(ele.loadDate)).format("lll")}</span>  <br/> */}
                                           
                                            Street Address : <span>{ele.addressEntity && ele.addressEntity.streetAddress}</span> <br/>
                                            City : <span>{ele.addressEntity && ele.addressEntity.town}</span> <br/>
                                            State : <span>{ele.addressEntity && ele.addressEntity.state}</span> <br/>
                                            ZIP Code  : <span>{ele.addressEntity && ele.addressEntity.zipCode}</span> <br/>

                                            {/* Driver Name : <span>{ele.driverName}</span> <br/>
                                            Scale Shrink Bushels : <span>{ele.estimatedHomeScaleShrinkBushels}</span> <br/>
                                            Estimated Load Bushels : <span>{ele.fieldEstimatedLoadBushels}</span> <br/> 
                                            Estimated Load Weight : <span>{ele.fieldEstimatedLoadWeight}</span> <br/>  */}
                                            </p>
                                       
                                      </div>
                                    </Modal>
    <h3 className="mainHeading connection-heading">Connected Farmers</h3>

     <div>
            {fetchingComplete ? (
              <CreateTable
                order={connectedorder}
                orderBy={connectedorderBy}
                headerRows={this.state.headerRows}
                rowData={this.convertorder(connections.connected)}
                delete={this.deleteRow}
                location={`${prevPath}${currentPage}/edit`}
                edit={this.editRow}
                onRequestSort={this.connectionhandleRequestSort}
                isMenuRequired={false}
              />
            ) : (
              <Loader />
            )}
          </div>
        <InviteButtonTabHeader
          header="Farmers Request"
          btnLabel="Invite Farmer"
          userType="FARMER"
          handleSubmit={this.handleFarmerInvite}
        />
         <div>
            {fetchingComplete ? (
              <CreateTable
                order={order}
                orderBy={orderBy}
                headerRows={this.state.orderheaderRows}
                rowData={this.convertorder(connections.connectionRequest)}
                delete={this.deleteRow}
                location={`${prevPath}${currentPage}/edit`}
                edit={this.editRow}
                onRequestSort={this.handleRequestSort}
                isMenuRequired={false}
              />
             ) : (
              <Loader />
            )} 
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowData: state.counterPartyReducer.counterPartyList,
    orderFetchComplete: state.counterPartyReducer.orderFetchComplete,
    orderRowData :state.counterPartyReducer.onboardCounterPartyList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear,
    connections: state.counterPartyReducer.connections
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      counterpartyListAction,
      getOnboardcounterpartyListAction,
      deleteCounterPartyAction,
      editCounterPartyAction,
      updateRequest,
      getFarmerListConnectionAction
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CounterpartyConnection));



// WEBPACK FOOTER //
// ./src/components/private/Counterparties/CounterpartyConnection.js